/** SA-1034 PR 5 (spec §3.9, ruling 5): the Current task block's words, in the Tasks section. */
export const CURRENT_TASK = 'Current task'
export const OVERDUE = 'overdue'

const join = (parts: Array<string | null | undefined | false>): string => parts.filter(Boolean).join(' · ')

/** `Pricing · due Fri 14:00 EEST · wait` — the seat, the due line, the kind when not plain work. */
export function currentTaskMeta(seat: string | null, due: string | null, kind: string): string {
  return join([seat, due && `due ${due}`, kind !== 'work' && kind])
}
